<template>
  <div class="contour">
    <template v-if="!loading">
      <ValidationObserver tag="form" ref="ValidationForm">
        <d-form-row>
          <d-col md="6" class="form-group">
            <label>Data de Vencimento</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <date-field :class="validateForm | showValidateError(invalid)"
               :disabled="true" v-model="fixedData.DueDate" />
              <div class="invalid-feedback d-block" v-if="validateForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Valor Líquido</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <decimal-field :class="validateForm | showValidateError(invalid)"
               :disabled="true" :type="'currency'" v-model="fixedData.Amount" />
              <div class="invalid-feedback d-block" v-if="validateForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Categoria</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <d-select :class="validateForm | showValidateError(invalid)"
                 v-model="formData.Category.Code">
                <option :value="null" selected>Selecione...</option>
                <option v-for="category in fieldOptions.AccountsReceivableCategory" :key="category.Code" :value="category.Code">
                  {{ category.Name }}
                </option>
              </d-select>
              <div class="invalid-feedback d-block" v-if="validateForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Descrição</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <d-form-input :class="validateForm | showValidateError(invalid)"
                type="text" v-model="formData.Description" />
              <div class="invalid-feedback d-block" v-if="validateForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Banco</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <d-select :class="validateForm | showValidateError(invalid)"
                 v-model="fixedData.BankAccount.Bank.Code" disabled>
                <option :value="null" selected>Selecione...</option>
                <option v-for="bank in fieldOptions.Banks" :key="bank.Code" :value="bank.Code">
                  {{ bank.Name }}
                </option>
              </d-select>
              <div class="invalid-feedback d-block" v-if="validateForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Conta</label>
            <ValidationProvider rules="required" v-slot="{ errors, invalid }">
              <d-select :class="validateForm | showValidateError(invalid)"
                 v-model="fixedData.BankAccount.Code" disabled>
                <option :value="null" selected>Selecione...</option>
                <option v-for="bankAccount in fieldOptions.BankAccounts" :key="bankAccount.Code" :value="bankAccount.Code">
                  {{ bankAccount.BankAccount }}-{{bankAccount.BankAccountDigit}}
                </option>
              </d-select>
              <div class="invalid-feedback d-block" v-if="validateForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
          <d-col md="6" class="form-group">
            <label>Cedente</label>
            <d-form-input type="text" v-model="formData.SupplierName" />
          </d-col>
          <d-col md="6" class="form-group">
            <label>Documento do Cedente</label>
            <ValidationProvider :rules="ruleIdentity" v-slot="{ errors, invalid }">
              <the-mask class="form-control" :class="validateForm | showValidateError(invalid)"
                type="tel" :mask="['###.###.###-##', '##.###.###/####-##']" v-model="formData.SupplierIdentity"/>
              <div class="invalid-feedback d-block" v-if="validateForm">
                {{ errors[0] }}
              </div>
            </ValidationProvider>
          </d-col>
        </d-form-row>
      </ValidationObserver>
      <div style="text-align: end">
        <b-button variant="primary" @click="AddAccountReceivable()">
          <i class="fas fa-exchange-alt mr-2" />
          Adicionar e Conciliar
        </b-button>
      </div>
    </template>
    <div v-else style="text-align: center; padding: 10px">
      <loader :small="true" :isLoading="true"/>
    </div>
  </div>
</template>

<script>
import DateField from "../../common/date-field";
import DecimalField from "../../common/decimal-field.vue";

export default {
  name: "BankConciliationReceivableAdd",
  components: {
    DateField,
    DecimalField
  },
  props: {
    fieldOptions:{
      type: Object,
      required: true,
    },
    conciliated:{
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      formData: this.FormDataDefault(),
      loading: false,
      validateForm: false
    }
  },
  mounted(){
  },
  computed:{
    fixedData(){
      return {
        DueDate: this.conciliated.EntryDate,
        Amount: this.conciliated.Amount,
        IdBankStatementDetails: this.conciliated.Id,
        BankAccount: {
          Code: this.conciliated.BankAccountCode ? this.conciliated.BankAccountCode : null,
          Bank: {
            Code: this.conciliated.Bank ? this.conciliated.Bank.Code : null
          }
        },
        InsertMode: 'C'
      }
    },
    ruleIdentity(){
      if(!this.formData.SupplierIdentity){
        return 'min:11';
      }else{
        return this.formData.SupplierIdentity.length > 11 ? 'min:14' : 'min:11';
      }
    }
  },
  methods:{
    FormDataDefault(){
      return {
        Category: { Code: null },
        Description: this.conciliated.Description,
        SupplierName: null,
        SupplierIdentity: null,
      }
    },
    AddAccountReceivable(){
      this.validateForm = true;
      this.$refs.ValidationForm.validate().then(isValid => {
        if (isValid) {
          if(this.conciliated.TypeConciliation == 1){
            this.loading = true;
            const payload = {
              ...this.formData,
              ...this.fixedData
            };
            this.$store.dispatch("AddAccountsReceivable", payload)
              .then(response => {
                if(response){
                  this.$emit('MadeConciliation', [`Conta à receber criada e conciliação feita com sucesso.`, "success", `Sucesso`]);
                }else{
                  this.$makeToast("Não foi possivel adicionar a conta à receber.", "danger", "Não foi possivel.");
                  this.loading = false;
                }
              })
              .catch(error => {
                this.$makeToast("Tente novamente.", "danger", "Um erro ocorreu ao adicionar.", error);
                this.loading = false;
              })
          }else{
            this.$makeToast("O item à esquerda não é do tipo válido para fazer a conciliação.", "danger", "Erro.");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.align-vertical-bottom {
  display: flex;
  justify-content: end; /* align horizontal */
  align-items: end;
  padding-bottom: 1px;
}
.contour {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BankConciliation/BankConciliationReceivableAdd.vue